import React from 'react';
import { ResponsivePie } from '@nivo/pie';

const PollChart = ({ data }) => (
	<ResponsivePie
		data={data}
		sortByValue
		margin={{ top: 40, right: 150, bottom: 80, left: 0 }}
		colors={{ scheme: 'category10' }}
		// legends={[
		// 	{
		// 		anchor: 'right',
		// 		direction: 'column',
		// 		// translateY: 56,
		// 		itemsSpacing: 0,
		// 		itemWidth: 150,
		// 		itemHeight: 50,
		// 		itemDirection: 'left-to-right',
		// 		itemOpacity: 1,
		// 		symbolSize: 18,
		// 		symbolShape: 'circle',
		// 	},
		// ]}
	/>
);

export default PollChart;
